<!-- begin::Page loader -->

<div style="margin-left: -80px; margin-top: -20px;">
	<ng4-loading-spinner [loadingText]="'Loading...'" [timeout]="1200000" [zIndex]="9999">
	</ng4-loading-spinner>

</div>
<!-- end::Page loader -->
<!-- begin:: Page -->
<router-outlet></router-outlet>
<!-- end:: Page -->
<app-quick-sidebar></app-quick-sidebar>
<app-scroll-top></app-scroll-top>
<app-tooltips></app-tooltips>
<!--begin::Base Scripts -->
<!--end::Base Scripts -->
<!--begin::Page Vendors -->
<!--end::Page Vendors -->
<!--begin::Page Snippets -->
<!--end::Page Snippets -->


// WEBPACK FOOTER //
// ./src/app/app.component.html